import { useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../utils/FirebaseConfig";
import { saveProfile } from "../../../services/mosqueContentRepository";
import {
    DEFAULT_CATS,
    normalizeCategoryKey,
    rolesFromCategory,
    titleCase,
} from "../utils/profailUtils";

const EMPTY_PROFAIL = {
    slug: "",
    contactPreferred: "whatsapp",
    no_whatsapp: "",
    facebook: "",
    instagram: "",
    youtube: "",
    gmaps: "",
    pegawai: [],
    bankAccounts: [],
};

const normalizePegawai = (list = []) => {
    const arr = Array.isArray(list) ? list : Object.values(list || {});
    return arr.map((p) => {
        const category = normalizeCategoryKey(p.category || "pengurusan");
        const label = p.label || titleCase(p.category || category);
        const roles = Array.isArray(p.roles) && p.roles.length ? p.roles : rolesFromCategory(category);

        return {
            id: p.id || crypto?.randomUUID?.() || String(Date.now() + Math.random()),
            category,
            label,
            nama: p.nama || "",
            jawatan: p.jawatan || "",
            hirarki: Number(p.hirarki ?? 99),
            gambar: p.gambar || "",
            roles,
        };
    });
};

const normalizeBanks = (list = []) => {
    const arr = Array.isArray(list) ? list : Object.values(list || {});
    return arr.map((b) => ({
        bank: b.bank || "",
        account: b.account || "",
        holder: b.holder || "",
    }));
};

export default function useMosqueProfail({ mosqueId, fallbackNama, fallbackEmel }) {
    const [loading, setLoading] = useState(true);
    const [original, setOriginal] = useState(null);
    const [draft, setDraft] = useState(null);

    useEffect(() => {
        const run = async () => {
            if (!mosqueId) {
                setLoading(false);
                setOriginal(null);
                setDraft(null);
                return;
            }

            setLoading(true);
            try {
                const ref = doc(db, "masajid", mosqueId);
                const snap = await getDoc(ref);

                if (!snap.exists()) {
                    const next = {
                        ...EMPTY_PROFAIL,
                        nama: fallbackNama || "",
                        emel: fallbackEmel || "",
                    };
                    await saveProfile(mosqueId, next);
                    setOriginal(next);
                    setDraft(next);
                    setLoading(false);
                    return;
                }

                const masjidData = snap.data() || {};
                const p = masjidData.profail || {};

                const normalized = {
                    ...EMPTY_PROFAIL,
                    ...p,
                    nama: p.nama || fallbackNama || "",
                    emel: p.emel || fallbackEmel || "",
                    pegawai: normalizePegawai(p.pegawai || []),
                    bankAccounts: normalizeBanks(p.bankAccounts || []),
                };

                await saveProfile(mosqueId, normalized);

                setOriginal(normalized);
                setDraft(normalized);
            } catch (e) {
                console.error("useMosqueProfail fetch error:", e);
            } finally {
                setLoading(false);
            }
        };

        run();
    }, [mosqueId, fallbackNama, fallbackEmel]);

    const cats = useMemo(() => {
        const fromPegawai = (draft?.pegawai || []).map((p) => p.category).filter(Boolean);
        return Array.from(new Set([...DEFAULT_CATS, ...fromPegawai]));
    }, [draft?.pegawai]);

    return { loading, original, setOriginal, draft, setDraft, cats };
}
